import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CommonModule as BluecrewCommonModule } from '../common/common.module';
import { PositionPageRoutingModule } from './position-routing.module';

import { PositionPage } from './position.page';
import { PipeModule } from '../pipes/pipe.module';
import { GetThisJobComponent } from './get-this-job/get-this-job.component';
import { ReviewSectionComponent } from './review-section/review-section.component';
import { RejectJobConfirmationComponent } from './reject-job-confirmation/reject-job-confirmation.component';
import { ScheduleConfirmationComponent } from './schedule-confirmation/schedule-confirmation.component';
import { PositionSchedulesCarouselComponent } from '../common/position-schedules-carousel/position-schedules-carousel.component';
import { JobUnavailableModalComponent } from './job-unavailable-modal/job-unavailable-modal.component';
import { SwiperModule } from 'swiper/angular';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { MultiSelectConfirmDismissComponent } from './multi-select/multi-select-confirm-dismiss/multi-select-confirm-dismiss.component';
import { GetTheseShiftsComponent } from './get-these-shifts/get-these-shifts.component';
import { MonthViewComponent } from './multi-select/month-view/month-view.component';
import { BlueshiftViewComponent } from './multi-select/blueshift-view/blueshift-view.component';
import { PopoverComponent } from './multi-select/blueshift-view/pop-over/pop-over.component';

@NgModule({
  imports: [
    BluecrewCommonModule,
    CommonModule,
    FormsModule,
    IonicModule,
    PositionPageRoutingModule,
    PipeModule,
    SwiperModule,
  ],
  declarations: [
    GetTheseShiftsComponent,
    GetThisJobComponent,
    MonthViewComponent,
    MultiSelectComponent,
    MultiSelectConfirmDismissComponent,
    PositionPage,
    RejectJobConfirmationComponent,
    ReviewSectionComponent,
    ScheduleConfirmationComponent,
    BlueshiftViewComponent,
    PositionSchedulesCarouselComponent,
    JobUnavailableModalComponent,
    PopoverComponent,
  ]
})
export class PositionPageModule {}
